<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              :isChat="isChat"
              expand>
        <form :class="isChat? formPosition : formPosition+' ml-lg-auto'">
            <div class="form-group mb-0">
                <base-input :placeholder="isChat?'Buscar conversación':'Buscar'"
                            class="input-group-alternative"
                            alternative=""
                            v-model="searchQuery"
                            v-on:keydown.enter.native="requestFind"
                            addon-right-icon="fas fa-search">
                </base-input>
            </div>
        </form>
        <ul v-if="!isChat" class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0" v-bind:style="{cursor:pointer}">
                    <div class="media align-items-center" slot="title">
                        <!--router-link to="/chat" class="icon icon-sm">
                            <i class="fas fa-comment text-white"></i>
                        </router-link-->
                        <span class="avatar avatar-sm rounded-circle" style="background-color: rgba(255, 255, 255, 0)">
                            <img alt="Image placeholder" src="img/brand/white.png">
                        </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold">{{user.name}} {{user.lastname_1}}</span>
                        </div>
                    </div>

                    <template>
                        <!--<div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
                        </div>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-single-02"></i>
                            <span>My profile</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Settings</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activity</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-support-16"></i>
                            <span>Support</span>
                        </router-link>
                        <div class="dropdown-divider"></div-->
                        <a class="dropdown-item">
                            <i class="fa fa-code-branch"></i>
                            <span>Versión {{$v.CURRENT_VERSION}}</span>
                        </a>
                        <a @click="logout" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Cerrar sesión</span>
                        </a>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
    export default {
        props: {
            isChat: Boolean
        },
        computed: {
            user() { return JSON.parse(localStorage.getItem(this.$v.STORE_KEYS.USER)) }
        },
        data() {
            return {
                activeNotifications: false,
                showMenu: false,
                searchQuery: '',
                pointer: 'pointer',
                formPosition: 'navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex'
            };
        },
        mounted() {

        },
        methods: {
            logout() {
                localStorage.clear()
                this.$router.push("/login")
            },
            requestFind(e) {
                e.preventDefault()
                this.$root.$emit('searchQuery', this.searchQuery)
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            }
        }
    };
</script>
